import HeaderLayout from '../../../Layout/HeaderLayout';
import { episodes } from '../../../Services/episodes';
import { connect } from 'react-redux';
import { IState, actions } from '../../../Store/reducer';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { CONFIG_MASTER_PATH } from '../../../Services/routeNames';
import "./EpisodeSelectionMaster.scss";

interface IEpisodeSelectionMasterProps {
    setEpisodeNumber: (episodeNumber: number) => void;
    episodeNumber: number;
}

interface IEpisodeSelectionMasterState {
    redirectToConfig: boolean;
}

class EpisodeSelectionMaster extends React.Component<IEpisodeSelectionMasterProps, IEpisodeSelectionMasterState> {

    constructor(props: IEpisodeSelectionMasterProps) {
        super(props);
        this.state = {
            redirectToConfig: false
        };
    }

    TOTAL_NUMBER_EPISODES: number = Object.keys(episodes).length;
    SIZE_OF_EPISODE: string = Number(1 / this.TOTAL_NUMBER_EPISODES * 100) + "%";

    setEpisodeNumberAndRedirect(episodeNumber: number) {
        if (episodeNumber !== this.props.episodeNumber) {
            this.props.setEpisodeNumber(episodeNumber);
        }
        this.setState({ redirectToConfig: true });
    }

    componentDidMount() {
        this.setState({
            redirectToConfig: false
        });
    }

    render() {
        if (this.state.redirectToConfig) {
            return <Navigate to={CONFIG_MASTER_PATH} />;
        } else {
            return (
                <div className="episodes-selection">
                    <HeaderLayout currentPage="episodes" hamburger={true} isMaster={true}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100.64 100"><g><path fill="#fff" d="m96.36,94.43v-11.78c0-.21.21-.43.43-.43h3.43c.21,0,.43-.21.43-.43V19.06c0-.21-.21-.43-.43-.43h-3.43c-.21,0-.43-.21-.43-.43V6.21c0-.21.21-.43.43-.43h3.43c.21,0,.43-.21.43-.43v-2.57c0-1.5-1.28-2.78-2.57-2.78H2.57C1.07,0,0,1.28,0,2.78v2.57c0,.21.21.43.43.43h3.43c.21,0,.43.21.43.43v11.78c0,.21-.21.43-.43.43H.43c-.21,0-.43.22-.43.43v62.31c0,.21.21.43.43.43h3.43c.21,0,.43.21.43.43v11.78c0,.21-.21.43-.43.43H.43c-.21,0-.43.22-.43.43v2.57c0,1.5,1.28,2.78,2.57,2.78h95.29c1.5,0,2.57-1.28,2.57-2.78v-2.57c0-.21-.21-.43-.43-.43h-3.43c0,.64-.22.43-.22.21h0Zm-71.52.43h-11.78c-.21,0-.43-.21-.43-.43v-11.78c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c0,.21-.21.43-.43.43Zm0-76.23h-11.78c-.21,0-.43-.21-.43-.43V6.21c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c0,.43-.21.64-.43.64h0Zm20.77,76.23h-11.78c-.21,0-.43-.21-.43-.43v-11.78c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c.21.21,0,.43-.43.43Zm0-76.23h-11.78c-.21,0-.43-.21-.43-.43V6.21c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c.21.43,0,.64-.43.64h0Zm20.99,76.23h-11.78c-.21,0-.43-.21-.43-.43v-11.78c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c.21.21,0,.43-.43.43Zm0-76.23h-11.78c-.21,0-.43-.21-.43-.43V6.21c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c.21.43,0,.64-.43.64h0Zm20.98,76.23h-11.78c-.21,0-.43-.21-.43-.43v-11.78c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c0,.21-.21.43-.43.43Zm0-76.23h-11.78c-.21,0-.43-.21-.43-.43V6.21c0-.21.21-.43.43-.43h11.78c.21,0,.43.21.43.43v11.78c0,.43-.21.64-.43.64h0Z" /></g></svg>
                        <span>Épisodes</span>
                    </HeaderLayout>

                    <div className="episodes-list">
                        {Object.entries(episodes).map(([id, episode]) =>
                            <div className="episode" onClick={() => this.setEpisodeNumberAndRedirect(Number(id))}>
                                <img src={`/image/episodes/${episode.banner}`} alt={episode.title} />
                            </div>
                        )}
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state: IState) => ({
    episodeNumber: state.master.episodeNumber,
});

const mapDispatchToProps = (dispatch: any) => ({
    setEpisodeNumber: (episodeNumber: number) => {
        dispatch({
            type: actions.master.SET_EPISODE_NUMBER,
            payload: {
                master: { episodeNumber }
            }
        })
    },

});

export default connect(mapStateToProps, mapDispatchToProps)(EpisodeSelectionMaster);